import React, {useMemo} from "react";
import {components} from "react-select";
import {IExoTemplate} from "../../../../store/exo/types";
import {telegramToPlainText, telegramToSafeHtml} from "../TelegramEditor/telegramHtml";
import {highlightMacros} from "../TelegramEditor/telegramMacros";
import Select from "../../../../components/Common/Select";

interface TemplateOption {
    value: number;
    label: string;
    preview: string;      // for search
    previewHtml: string;  // for display
    template: IExoTemplate;
}

interface TemplateSelectProps {
    selectedId?: number | null;
    templates: IExoTemplate[];
    onApply: (body: string, template: IExoTemplate) => void;
    isSearchable?: boolean;
    isLoading?: boolean;
    disabled?: boolean;
    placeholder?: string;
}

const SingleValue = ({children, ...props}: any) => (
    <components.SingleValue {...props}>
        <em className="text-muted small">Template:</em> {children}
    </components.SingleValue>
);

const Option = (props: any) => (
    <components.Option {...props}>
        <div className="fw-medium text-truncate mb-1">{props.data.label}</div>
        {props.data.preview.trim() ? (
            <div className="text-muted small tg-selected-preview"
                 dangerouslySetInnerHTML={{__html: props.data.previewHtml}}
            />
        ) : (<div className="text-muted small"><em>Empty template</em></div>)}
    </components.Option>
);

const SelectExoTemplate: React.FC<TemplateSelectProps> = ({
                                                              selectedId,
                                                              templates,
                                                              onApply,
                                                              isSearchable = false,
                                                              isLoading = false,
                                                              disabled = false,
                                                              placeholder = "Apply template...",
                                                          }) => {

    const toOptions = (templates: IExoTemplate[]) =>
        templates.map(t => ({
            value: t.id,
            label: t.name,
            preview: telegramToPlainText(t.body_msg),
            previewHtml: highlightMacros(telegramToSafeHtml(t.body_msg)),
            template: t,
        }))

    const options = useMemo<TemplateOption[]>(() => toOptions(templates), [templates]);
    const selectedOption = useMemo<TemplateOption | undefined>(() => options.find(o => o.value === selectedId), [options, selectedId]);

    const handleSelect = (option: TemplateOption | null) => {
        if (!option) return;
        onApply(option.template.body_msg, option.template);
    };

    const optionSearch = (option: any, input: any) => {
        const q = input.trim().toLowerCase();
        if (!q) return true;

        return (
            option.data.label.toLowerCase().includes(q) ||
            option.data.preview.toLowerCase().includes(q)
        );
    }

    return (
        <Select
            options={options}
            value={selectedOption || null}
            onChange={handleSelect}
            placeholder={placeholder}
            isSearchable={isSearchable}
            isLoading={isLoading}
            isDisabled={disabled}
            filterOption={optionSearch}
            components={{SingleValue, Option}}
            noOptionsMessage={() => (templates.length ? "No templates found" : "No templates yet")}
        />
    );
};

export default SelectExoTemplate;